var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barcode-container"},[_c('canvas',{ref:"barcodeCanvas"}),_c('div',{staticClass:"fiscalCode-text"},[_vm._v("*"+_vm._s(_vm.fiscalCode)+"*")])])}
var staticRenderFns = []

export { render, staticRenderFns }